<template>
  <div>
    <el-form ref="form" size="mini" :model="data" status-icon :rules="formRules">
      <el-row class="item-title">
        <el-col :span="24">
          <span>定义新产品的规则</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <span>新品标准</span>
          <el-form-item prop="newProduct">
            <el-input v-model.trim="data.newProduct" />
          </el-form-item>
          <span>天</span>
          <span style="margin:0;">（新建商品在**天范围内，系统自动打上</span>
          <span style="color:#FF8100;margin:0;">新品</span>
          <span>标签）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>定义滞销品的规则</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <span>滞销标准</span>
          <el-form-item prop="drug">
            <el-input v-model.trim="data.drug" />
          </el-form-item>
          <span>天</span>
          <span style="margin:0;">（当商品连续**天没有任何交易，系统自动打上</span>
          <span style="color:#FF8100;margin:0;">滞销品</span>
          <span>标签）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>定义睡眠客户的规则</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <span>睡眠标准</span>
          <el-form-item prop="sleep">
            <el-input v-model.trim="data.sleep" />
          </el-form-item>
          <span>天</span>
          <span style="margin:0;">（当客户连续**天没有任何交易，系统自动将该客户打上</span>
          <span style="color:#FF8100;margin:0;">睡眠</span>
          <span>标签）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>定义流失客户的规则</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <span>流失标准</span>
          <el-form-item prop="loss">
            <el-input v-model.trim="data.loss" />
          </el-form-item>
          <span>天</span>
          <span style="margin:0;">（当客户连续**天没有任何交易，系统自动将该客户打上</span>
          <span style="color:#FF8100;margin:0;">流失</span>
          <span>标签）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>退货审批自动通过规则</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <span>自动通过期限</span>
          <el-form-item prop="autoPass">
            <el-input v-model.trim="data.autoPass" />
          </el-form-item>
          <span>天</span>
          <span style="margin:0;">（当客户提交退货后，如果*天内没有审批，则自动</span>
          <span style="color:#FF8100;margin:0;">审批通过</span>
          <span>）</span>
        </el-col>
      </el-row>
    </el-form>
    <el-alert title="数据保存成功后，在隔天生效" type="warning" :closable="false" />
    <div class="item-footer">
      <el-button type="primary" size="mini" style="width:80px;" @click="submit">保 存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: {
        newProductId: 0,
        newProduct: null, //定义新产品的规则
        drugId: 0,
        drug: null, //定义滞销品的规则
        sleepId: 0,
        sleep: null, //定义睡眠客户的规则
        lossId: 0,
        loss: null, //定义流失客户的规则
        autoPassId: 0,
        autoPass: null, //退货审批自动通过规则
      },
      isNull: false,
      saveData: [],
      formRules: {
        newProduct: [
          { required: true, message: "不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
        drug: [
          { required: true, message: "不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
        sleep: [
          { required: true, message: "不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
        loss: [
          { required: true, message: "不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
        autoPass: [
          { required: true, message: "不能为空" },
          { validator: this.$commonJs.validateRules.int },
        ],
      },
      api: require("@/api/sy/opt").default,
    };
  },
  methods: {
    getData() {
      this.api.list({ Code: "MARKET" }).then((res) => {
        
        if (res.Data.length == 0) {
          this.isNull = true;
        }
        res.Data.forEach((item) => {
          switch (item.OptText) {
            case "NewProduct":
              this.data.newProductId = item.OptId;
              this.data.newProduct = item.OptValue;
              break;
            case "Drug":
              this.data.drugId = item.OptId;
              this.data.drug = item.OptValue;
              break;
            case "Sleep":
              this.data.sleepId = item.OptId;
              this.data.sleep = item.OptValue;
              break;
            case "Loss":
              this.data.lossId = item.OptId;
              this.data.loss = item.OptValue;
              break;
            case "AutoPass":
              this.data.autoPassId = item.OptId;
              this.data.autoPass = item.OptValue;
              break;
          }
        });
      });
    },
    submit() {
      let form = this.formValidate();
      form.then((valid) => {
        if (!valid) return;
        this.saveData = [];

        this.saveData.push({
          OptId: this.data.newProductId,
          Code: "MARKET",
          OptValue: this.data.newProduct,
          OptText: "NewProduct",
        });
        this.saveData.push({
          OptId: this.data.drugId,
          Code: "MARKET",
          OptValue: this.data.drug,
          OptText: "Drug",
        });
        this.saveData.push({
          OptId: this.data.sleepId,
          Code: "MARKET",
          OptValue: this.data.sleep,
          OptText: "Sleep",
        });
        this.saveData.push({
          OptId: this.data.lossId,
          Code: "MARKET",
          OptValue: this.data.loss,
          OptText: "Loss",
        });
        this.saveData.push({
          OptId: this.data.autoPassId,
          Code: "MARKET",
          OptValue: this.data.autoPass,
          OptText: "AutoPass",
        });

        if (this.isNull) {
          this.api.save(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.isNull = false;
              this.$message.success("保存成功");
            }
          });
        } else {
          this.api.update(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.$message.success("保存成功");
            }
          });
        }
      });
    },
    formValidate() {
      return this.$refs.form
        .validate()
        .then((valid) => {
          return valid;
        })
        .catch(() => {
          this.$notify({
            title: "提示",
            message: "请检查相关字段（红色）填写是否规范",
            type: "warning",
            position: "top-left",
          });
          return false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.item-title {
  margin-bottom: 10px;
  span {
    font-size: 18px;
    color: #606266;
  }
}
.item-content {
  margin-bottom: 30px;
  span {
    font-size: 14px;
    line-height: 29px;
    float: left;
    margin-right: 12px;
    color: #606266;
  }
}
.item-footer {
  margin-top: 10px;
  padding: 10px 20px 20px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top: 1px solid #e4e7ed;
}
.el-alert {
  padding-left: 5px;
  background: #cae2ff;
  color: #606266;
}
.el-form {
  padding: 0px 13px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
  margin-right: 12px;
  width: 100px;
  float: left;
}
</style>